import { AlertTriangle, RefreshCw } from 'lucide-react';

import { GhostButton, GlassCard, PrimaryButton } from '@/lib/ui';

import { useSignOut } from '../hooks';

interface SessionLoadErrorProps {
  onRetry: () => void;
}

/**
 * Shown by the guarded layouts when there is a token but `/me` could not be
 * loaded, so we don't know yet which screen the user belongs on.
 */
export function SessionLoadError({ onRetry }: SessionLoadErrorProps) {
  const signOut = useSignOut();

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <GlassCard className="w-full max-w-md space-y-4 text-center">
        <div className="flex justify-center">
          <AlertTriangle className="size-12 text-destructive" aria-hidden="true" />
        </div>
        <div className="space-y-1">
          <h2 className="text-lg font-semibold">We couldn&apos;t load your account</h2>
          <p className="text-sm text-muted-foreground">
            Check your connection and try again, or sign out and back in.
          </p>
        </div>
        <div className="flex justify-center gap-2">
          <GhostButton size="sm" onClick={onRetry}>
            <RefreshCw className="mr-1.5 size-3.5" aria-hidden="true" />
            Try again
          </GhostButton>
          {/* The layout redirects to /login once the token is cleared. */}
          <PrimaryButton size="sm" onClick={signOut}>
            Sign out
          </PrimaryButton>
        </div>
      </GlassCard>
    </div>
  );
}
